import numeral from 'numeral'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'

export const displayPhone = (phone) => {
  return phone
    .replace(/[^\d]+/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export const displayRatioAsPercent = (ratio, precision) => {
  if (precision || precision >= 0) {
    return Number(ratio * 100).toFixed(precision) + '%'
  }
  return `${ratio * 100}%`
}

export const displayDollars = (number) => {
  return numeral(number).format('$0,0.00')
}

export const displayMiles = (number) => {
  let num = numeral(number).format('0,0')
  return `${num} miles`
}

export const convertDecimalToPercent = (number) => {
  return `${(number * 100).toFixed(2)}%`
}

export const displayDollarsWithoutCents = (number) => {
  return numeral(number).format('$0,0')
}

export const displayPercentage = (number) => {
  return `${number}%`
}

export const displayTwoDecimalPercent = (number) => {
  return `${parseFloat(number).toFixed(2)}%`
}

export const scrollToHeader = () => {
  const header = document.querySelector('.header')
  header && header.scrollIntoView()
}

export const displaySnakeCaseAsTitleCase = (text) => {
  return text
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(?: |\b)(\w)/g, function (key) {
      return key.toUpperCase()
    })
}

export const displayCamelCaseAsTitleCase = (text) => {
  return text
    .replace(/([A-Z])/g, ' $1')
    .replace(/(?: |\b)(\w)/g, function (key) {
      return key.toUpperCase()
    })
}

export const displayEllipsisWithMaxChar = (text, length) => {
  if (text.length > length) {
    return startCase(capitalize(text.substring(0, length))) + '...'
  } else {
    return startCase(capitalize(text))
  }
}

export const displayMMDDYYYY = (text) => {
  if (!text) return null
  const parts = text.split(/(\d{2})(\d{2})(\d{4})/)
  return `${parts[1]}-${parts[2]}-${parts[3]}`
}
